import {
	Box,
	CircularProgress,
	Divider,
	IconButton,
	SelectChangeEvent,
	Snackbar,
	Stack,
	Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import { CommentIcon, CommentIcon2, LockIcon, ModalCloseIcon } from '../Icons';
import CustomButton from '../CustomButton/CustomButton';
import CustomDataGrid2 from '../CustomDataGrid/CustomDataGrid2';
import { Order, OrderFulfillmentLifeCycle } from '../Main/Chat/ChatMessage/ChatMessage';
import {
	canEditOrder,
	formatPriceValue,
	getBaseRoute,
	setOrderStatus,
	truncateField,
} from '@src/helpers/Helpers';
import { AxiosError, AxiosResponse } from 'axios';
import { ApplicationContext } from '@src/contexts/ApplicationContext';
import { CustomAlertType } from '@src/pages/Catalogs';
import CustomAlert from '../CustomAlert/CustomAlert';
import Papa from 'papaparse';
import CustomTab from '../CustomTab/CustomTab';
import CustomSelect from '../CustomSelect/CustomSelect';
import LabeledSelectField, { StatusList, StyledMenuItem } from '../CustomSelect/LabeledSelectField';
import CustomStepper from '../Stepper/CustomStepper';
import { error } from 'console';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { RESTAURANT } from '@src/Constants';
import usePermission from '@src/hooks/usePermission';
import { ALL_PERMISSION_MAP } from '@src/helpers/Permission';
import CustomPermission from '../Permissions/CustomPermission';
import CustomTooltip from '../CustomTootip/CustomTooltip';
import { IsMobileWidth } from '../MediaQueryUtils';
import CustomTextButton from '../CustomButton/CustomTextButton';
import LabeledTextField from '../CustomTextField/LabeledTextField';
import CustomModal from '../CustomModal';
import ProductCustomCard from '../CustomCard/ProductCustomCard';
import ConfirmModal from '../ConfirmModal/ConfirmModal';
import ProductCard from '../CustomCard/ProductCard';

import ProductDetails from '../ProductDetails/ProductDetails';

import OrderStatusExtraInfo, {
	StatusOption,
} from '@src/pages/Orders/Components/OrderStatusExtraInfo';

import StatusDetails from '@src/pages/Orders/Components/StatusDetails';

import { Option } from '@src/interfaces/type';
import Loading from '../Loading/Loading';
import PaymentStatus from '../PaymentStatus';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: auto;
	overflow: scroll;
	letter-spacing: 0.28px;
`;

const MobileContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 90vh;
	overflow: hidden;
	letter-spacing: 0.28px;
	#order-details {
		display: flex;
		flex-direction: column;
		gap: 10px;
		padding: 16px;
		flex-shrink: 0;
		.field {
			display: flex;
			gap: 6px;
			color: #5c5c5c;
			font-size: 14px;
			font-weight: 500;
			span {
				font-weight: 700;
			}
		}
	}
`;

const Status = styled.div<{ id?: string }>`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 23px;
	border-radius: 4px;
	font-size: 14px;
	font-weight: 700;
	line-height: 19.1px;
	padding: 2px 6px;
	text-align: center;
	width: auto;
`;

const OrderDetails = styled.div`
	display: flex;
	align-items: center;
	gap: 40px;
	width: 100%;
	height: 50px;
	padding: 16px;
	.orderFields {
		display: flex;
		gap: 14px;
		align-items: center;
		height: 50px;
		width: 300px;
		font-size: 12px;
		line-height: 16px;
		@media screen and (max-width: 900px) {
			gap: 10px;
			height: 16px;
			width: 60vw;
		}
		@media screen and (max-width: 360px) {
			gap: 10px;
			height: 16px;
			width: 190px;
		}
		p {
			color: var(--lighter-text-color);
		}
		span {
			display: flex;
			gap: 4px;
			color: #333;
		}
	}

	@media screen and (max-width: 900px) {
		flex-direction: column;
		height: auto;
		gap: 10px;
		align-items: flex-start;
	}
`;

const BottomContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	@media screen and (max-width: 750px) {
		flex-direction: column;
		gap: 14px;
		align-items: flex-start;
	}
`;

const AmountContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	padding: 8px;
	p {
		color: var(--default-text-color);
		font-size: 14px;
		font-weight: 700;
		line-height: 18.2px;
		width: 160px;
	}
	span {
		color: var(--default-text-color);

		font-size: 13px;

		font-weight: 500;

		line-height: 18.2px;
	}
`;

const productDetailsModalStyles = {
	backgroundColor: 'background.paper',

	borderRadius: '4px',

	boxShadow: '24px',

	maxWidth: '600px',

	maxHeight: '444px',

	'@media (max-width: 600px)': {
		width: '90%',

		maxWidth: '90%',

		maxHeight: '645px',

		height: '645px',
	},
};

export interface PaymentData {
	paymentTerms: Option[];

	paymentModes: Option[];

	paymentStatuses: Option[];
}

const CommentContainer = styled.div`
	padding: 16px;
	display: flex;
	gap: 10px;
	color: #333;
	font-size: 14px;
	font-weight: 600;
`;

interface Options {
	id: number;
	name: string;
	color: string;
	background: string;
	statusID: string;
	validationId: number;
	group_id: number;
}

//For Mobile View
const StyledBottomBtnContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 100px;

	padding: 16px;

	background: var(--chat-header-bg);

	border: 1.5px solid var(--gray-color-light);

	z-index: 10;

	flex-shrink: 0; // Prevents resizing when the content overflows

	position: absolute;

	bottom: 0;

	overflow: auto;
`;

const StyledTextButton = styled.button`
	color: var(--color-font-grey);
	font-size: 14px;
	font-weight: 600;
	line-height: 18.2px;
	letter-spacing: -0.28px;
	text-decoration-line: underline;
	cursor: pointer;
	background: none;
	border: none;
	padding: 0;
`;

const ProductContainer = styled.div({
	background: '#F1F1F1',
	paddingTop: '2px',
	overflowY: 'auto',
	flexGrow: 1, // Ensure it takes up remaining space and allows scrolling
	marginBottom: '68px',
	paddingBottom: '2px',
});

interface ViewOrderProps {
	orderDetails: Order;
	setOrderDetails: (data: Order) => void;
	orderInfo: any;
	setOrderInfo: any;
	title: string | undefined;
	alert: CustomAlertType;
	setAlert: (data: CustomAlertType) => void;
	handleClose: any;
	currentUser: any;
	orders?: any;
	setOrders?: any;
	displayCustomError?: any;
	chatTimeStamp?: any;
	setApiCall: (data: boolean) => void;
	isOrderPage?: boolean;
}

function shouldShowCreditWarning(credits: any) {
	if (credits) {
		const { allowNewOrders, creditAvailable, isActive } = credits || {};
		// if (allowNewOrders === false && creditAvailable <= 0) { // TODO : To be removed
		if (creditAvailable <= 0 && isActive) {
			return true;
		}
	}

	return false;
}

const ViewOrder: React.FC<ViewOrderProps> = ({
	title,
	alert,
	setAlert,
	handleClose,
	currentUser,
	orderInfo,
	setOrderInfo,
	orderDetails,
	setOrderDetails,
	orders = [],
	setOrders,
	displayCustomError,
	chatTimeStamp,
	setApiCall,
	isOrderPage,
}) => {
	const { apiService }: any = React.useContext(ApplicationContext);
	const { id, waId } = useParams();
	const navigate = useNavigate();
	const isSupplier = currentUser?.type?.toLowerCase() !== RESTAURANT;
	const isMobileWidth = IsMobileWidth();

	const showCreditWarning = shouldShowCreditWarning(orderDetails?.credits);

	//Permission
	const checkPermission = usePermission();
	const editOrderPermission = checkPermission(ALL_PERMISSION_MAP?.GENERAL?.ORDER?.UPDATE, waId);
	const viewOrderPermission = checkPermission(ALL_PERMISSION_MAP?.GENERAL?.ORDER?.VIEW, waId);
	const viewOrderHistory = checkPermission(ALL_PERMISSION_MAP?.GENERAL?.ORDER?.READ_HISTORY, waId);

	const [windowDimensions, setWindowDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight,
	});
	const [loading, setLoading] = useState(true);
	const [disable, setDisable] = useState(false);
	const [tabValue, setTabValue] = useState('1');
	const [selectedId, setSelectedId] = useState('');
	const [status, setStatus] = useState<StatusList>([]);
	const [allOptions, setAllOptions] = useState<Options[]>([]);
	const [steps, setSteps] = useState([]);
	const [commentPreview, setCommentPreview] = useState(false);
	const [shareModal, setShareModal] = useState(false);
	const [confirmPopUp, setConfirmPopUp] = useState(false);
	const [data, setData] = useState(null);
	const [selectedOption, setSelectedOption] = useState<any>(null);
	const [detailsMiodal, setDetailsModal] = useState(false);
	const [details, setDetails] = useState([]);
	const [orderStatusModal, setOrderStatusModal] = useState(false);
	const [paymentOptions, setPaymentOptions] = useState<PaymentData | null>(null);
	const isRestaurant = currentUser?.type?.toLowerCase() === RESTAURANT;
	const [paymentHistory, setPaymentHistory] = useState([]);

	const [addPaymentStatusLoading, setAddPaymentStatusLoading] = useState(false);
	const [addPaymentStatusError, setAddPaymentStatusError] = useState<null | boolean>(null);

	const OrderDetailsComponent = () => {
		return (
			<>
				<OrderDetails style={mobileWidth ? { paddingBottom: 8 } : {}}>
					{detailsArray?.map((info: any, index) => {
						if (
							info?.key === 'Request Delivery:' &&
							orderDetails?.requestedDeliveryDate === 'Invalid date'
						) {
							return null;
						}
						return (
							<div
								style={
									mobileWidth
										? {
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
												width: '100%',
										  }
										: {}
								}
							>
								<div
									style={mobileWidth ? { width: '100%', justifyContent: 'space-between' } : {}}
									className="orderFields"
								>
									<p>{info?.key}</p>
									<span>
										{info?.value}
										{/* {info?.key === 'Ordered' ? chatTimeStamp : null} */}
									</span>
								</div>
								{/* {mobileWidth && index === 0 ? (
									<Status>{orderDetails?.orderStatus?.name}</Status>
								) : null} */}
							</div>
						);
					})}
				</OrderDetails>
				<OrderDetails style={mobileWidth ? { paddingTop: 0 } : {}}>
					<Stack
						direction={mobileWidth ? 'column' : 'row'}
						sx={mobileWidth ? { width: '100%' } : {}}
						gap={1}
					>
						{orderDetails?.credits?.isActive && (
							<Box
								className="orderFields"
								style={mobileWidth ? { width: '100%', justifyContent: 'space-between' } : {}}
							>
								<p>Credit Status</p>
								<span
									className={
										'credit_status-' +
										(orderDetails?.credits?.creditAvailable < 0 ? 'NO_CREDIT' : 'AVAILABLE')
									}
								>
									{orderDetails?.credits?.creditAvailable < 0 ? 'Not Available' : 'Available'}
								</span>
							</Box>
						)}
						<Box
							className="orderFields"
							style={mobileWidth ? { width: '100%', justifyContent: 'space-between' } : {}}
						>
							<p>Payment Status</p>
							<span className={'payment_status-' + orderDetails?.paymentStatus?.name}>
								{orderDetails?.paymentStatus?.name}
							</span>
						</Box>
					</Stack>
				</OrderDetails>
				<div
					style={{
						display: 'flex',

						flexDirection: 'column',

						gap: '12px',

						padding: '0 16px',

						marginBottom: '12px',
					}}
				>
					<StatusDetails
						data={orderDetails?.orderFulfillmentLifeCycle?.accepted}
						title="Sales Data"
					/>

					<StatusDetails
						data={orderDetails?.orderFulfillmentLifeCycle?.readyToShip}
						title="Invoice"
					/>

					<StatusDetails
						data={orderDetails?.orderFulfillmentLifeCycle?.shipped}
						title="Payment Attachment"
					/>
				</div>

				<div style={{ padding: '0 16px', height: 'auto', width: '100%', marginBottom: '200px' }}>
					{orderDetails?.products?.map((product: any) => {
						return <ProductCard data={product} noCheckbox showDetails={showDetails} />;
					})}
				</div>

				<StyledBottomBtnContainer
					style={
						isMobileWidth ? { height: 'unset', padding: 0, position: 'fixed' } : { padding: 4 }
					}
				>
					{orderDetails?.comments ? (
						<CommentContainer style={{ whiteSpace: 'pre-line' }}>
							<CommentIcon />

							<p>{orderDetails?.comments}</p>
						</CommentContainer>
					) : null}

					<AmountContainer style={{ display: 'flex', flexDirection: 'column' }}>
						<span>Total Items: {orderDetails?.products?.length}</span>
						<span style={{ fontWeight: 'bold' }}>Total Amount: ₹ {orderDetails?.total}</span>
						<span style={{ fontWeight: 'bold' }}>
							Less Rewards: ₹ {formatPriceValue(orderDetails?.rewardsDiscount || 0)}
						</span>
						<span style={{ fontWeight: 'bold' }}>
							Payable Amount: ₹{' '}
							{formatPriceValue(orderDetails?.total - orderDetails?.rewardsDiscount || 0)}
						</span>
					</AmountContainer>
				</StyledBottomBtnContainer>
			</>
		);
	};

	const OrderHistory = () => {
		return (
			<CustomStepper
				steps={steps}
				style={
					windowDimensions?.width > 800
						? { margin: '60px' }
						: { marginTop: '30px', marginLeft: '8px' }
				}
			/>
		);
	};

	const capturePaymentDetails = (payload: any) => {
		setAddPaymentStatusLoading(true);
		apiService.capturePaymentDetails(
			(res: AxiosResponse) => {
				setAddPaymentStatusLoading(false);
				setAddPaymentStatusError(false);
				// setAlert({
				// 	message: 'Payment Captured Successfully',
				// 	severity: 'success',
				// });
				getPaymentHistory();
				// if (isOrderPage) {
				setApiCall(true);
				// }
			},
			(err: AxiosError) => {
				setAddPaymentStatusError(true);
				setAddPaymentStatusLoading(false);
				displayCustomError(err);
			},
			orderDetails?.orderId,
			payload
		);
	};

	const tabs = [
		{
			label: 'Order Details',
			value: '1',
			content: viewOrderPermission ? (
				<OrderDetailsComponent />
			) : (
				<CustomPermission
					icon={<LockIcon />}
					title="We are sorry..."
					paragraph="You do not have permission to view order details. Contact 
an administrator to get permission."
				/>
			),
		},
		{
			label: 'Order History',
			value: '2',
			content: viewOrderHistory ? (
				<OrderHistory />
			) : (
				<CustomPermission
					icon={<LockIcon />}
					title="We are sorry..."
					paragraph="You do not have permission to view order history. Contact 
an administrator to get permission."
				/>
			),
		},
		{
			label: 'Payment Status',
			value: '3',
			content: !isRestaurant ? (
				<PaymentStatus
					paymentHistory={paymentHistory}
					capturePaymentDetails={capturePaymentDetails}
					paymentOptions={paymentOptions}
					addPaymentStatusLoading={addPaymentStatusLoading}
					addPaymentStatusError={addPaymentStatusError}
					orderDetails={orderDetails}
					setAddPaymentStatusError={setAddPaymentStatusError}
				/>
			) : (
				<CustomPermission
					icon={<LockIcon />}
					title="We are sorry..."
					paragraph="You do not have permission to view payment history. Contact
		an administrator to get permission."
				/>
			),
		},
	];

	const showDetails = (product: any) => {
		setDetails(product);
		setDetailsModal(true);
	};

	const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
		setTabValue(newValue);
	};

	const updateWindowDimensions = () => {
		setWindowDimensions({
			width: window.innerWidth,
			height: window.innerHeight,
		});
	};

	const mobileWidth = windowDimensions?.width <= 800;
	const getGridWidth = () => {
		if (windowDimensions?.width > 900) {
			return '1074px';
		} else {
			return '100%';
		}
	};

	const gridStyling = {
		background: 'white',
		color: '#5C5C5C',
		cursor: 'pointer',
		width: getGridWidth(),
		transition: 'height 0.3s ease',
		height: 'calc(100vh - 300px)',
		' .MuiDataGrid-cell': {
			border: 'none',
			outline: 'none !important',
		},
		' .MuiDataGrid-row': {
			borderBottom: '1px solid #F1F1F1',
		},
		' .MuiDataGrid-columnHeader': {
			border: 'none',
			outline: 'none !important',
		},
		'.MuiDataGrid-columnHeaders': {
			overflow: 'visible',
			position: 'relative',
			zIndex: 1,
			background: '#FFECB3 !important',
		},
		'.MuiDataGrid-columnHeaderTitleContainer': {
			overflow: 'visible',
		},
		'.MuiDataGrid-columnHeaderTitle': {
			color: 'black',
			fontWeight: 700,
		},
		'.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
			outline: 'none !important',
			border: 'none !important',
		},
	};

	const detailsArray = [
		{ key: 'Order Id:', value: `#${orderDetails?.timeId}` },
		{ key: 'Ordered:', value: orderDetails?.orderDate },
		{ key: 'Request Delivery:', value: orderDetails?.requestedDeliveryDate },
	];

	const columns = [
		// {
		// 	field: 'id',
		// 	headerName: 'Product ID',
		// 	width: 150,
		// 	align: 'center',
		// 	headerAlign: 'center',
		// },
		{
			field: 'name',
			headerName: 'Part Name',
			width: 300,
			renderCell: (params: any) => {
				const name = params?.row?.name;
				return (
					<div
						style={{
							display: 'flex',
							gap: '8px',
							alignItems: 'center',
						}}
						title={name}
					>
						<img
							src={params?.row?.images?.[0]?.image || params?.row?.image || '/placeholderImage.svg'}
							alt="product-img"
							width="24px"
							height="24px"
						/>
						{params?.row?.name?.length > 33 ? (
							<CustomTooltip title={params?.row?.name} placement="top">
								<p
									style={{
										maxWidth: '260px',
										whiteSpace: 'nowrap',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
									}}
								>
									{params?.row?.name}
								</p>
							</CustomTooltip>
						) : (
							<p
								style={{
									maxWidth: '260px',
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
								}}
							>
								{params?.row?.name}
							</p>
						)}
					</div>
				);
			},
		},
		{
			field: 'price',
			headerName: 'Unit Price(INR)',
			width: 200,
		},
		{
			field: 'quantity',
			headerName: 'Quantity',
			width: 200,
		},
	];
	const onRowsSelectionHandler = () => {};

	const handleRowClickListView = (params: any, event: any) => {};

	const exportToCsv = (tableData: any, forSharing = false) => {
		const supplierInfo = {
			'Supplier Name': tableData?.supplier?.name,
		};

		const restaurantInfo = {
			'Dealer Name': tableData?.restaurant?.name,
		};

		const orderData = [
			['Dealer Name', tableData?.restaurant?.name],
			['Supplier Name', tableData?.supplier?.name],
			['Order Id', tableData?.id],
			['Order Date', tableData?.orderDate],
			['Delivery Date', tableData?.deliveryDate],
			['Order Status', tableData?.orderStatus?.name],
			['Total', `₹ ${tableData?.total}`],
			[], // Add an empty row for separation
		];

		const productData = [
			...tableData?.products?.map((item: any) => ({
				'Product ID': item?.id,
				'Part Name': item?.name,
				Unit: item?.unit,
				Price: `₹ ${item?.price}`,
				Quantity: item?.quantity,
				Total: `₹ ${item?.total}`,
			})),
		];

		const csvData = Papa.unparse({
			fields: ['Key', 'Value'],
			data: orderData.concat(Object.entries(supplierInfo), Object.entries(restaurantInfo)),
		});

		const csvData2 = Papa.unparse({
			fields: ['Product ID', 'Part Name', 'Unit', 'Price', 'Quantity', 'Total'],
			data: productData,
		});

		if (!forSharing) {
			const blob = new Blob([csvData + '\n' + csvData2], { type: 'text/csv' });
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = 'order_items.csv';
			a.click();
			window.URL.revokeObjectURL(url);
			setShareModal(false);
		}

		return csvData + '\n' + csvData2;
	};

	const shareData = async (tableData: any) => {
		const csvData = exportToCsv(tableData, true);

		if (navigator?.share) {
			const csvBlob = new Blob([csvData], { type: 'text/csv' });
			const shareData = {
				title: 'Order List with Products',
				text: 'Here is the order list with products CSV file.',
				files: [new File([csvBlob], 'order_items.csv', { type: 'text/csv' })],
			};
			try {
				await navigator.share(shareData);
				console.log('Share Successful');
				setShareModal(false);
			} catch (error) {
				console.error('Sharing failed', error);
			}
		} else {
			window?.alert('Web Share not supported');
		}
	};

	const handleChange = (event: SelectChangeEvent<unknown>) => {
		const selectedValue = event.target.value;
		const selectedOption = allOptions?.find((option) => option?.id === selectedValue);
		if (selectedOption?.name && selectedOption?.id !== orderDetails?.orderStatus?.id) {
			const data = {
				statusId: selectedOption?.statusID,
			};

			if ([2, 4, 5].includes(Number(selectedValue) as number)) {
				setOrderStatusModal(true);
				setSelectedOption({
					color: selectedOption?.color,
					color_bg: selectedOption?.background,
					name: selectedOption?.name,
					id: selectedOption?.id,
					validation_order: selectedOption?.validationId,
					group_id: selectedOption?.group_id,
				});
				return;
			}

			setSelectedOption({
				color: selectedOption?.color,
				color_bg: selectedOption?.background,
				name: selectedOption?.name,
				id: selectedOption?.id,
				validation_order: selectedOption?.validationId,
				group_id: selectedOption?.group_id,
			});

			//@ts-ignore
			setData(data);
			setConfirmPopUp(true);
		}
	};

	const statusUpdate = (
		selectedValue: any,

		selectedOption: any,

		data: any,

		orderFulfillmentLifeCycle: any
	) => {
		setLoading(true);
		setDisable(true);

		apiService.updateOrderStatus(
			data,

			(response: AxiosResponse) => {
				setAlert({
					message: 'Order Status Updated Successfully',

					severity: 'success',
				});

				setSelectedId(selectedValue as string);

				setOrderDetails({
					...orderDetails,

					orderFulfillmentLifeCycle: orderFulfillmentLifeCycle,

					orderStatus: {
						color: selectedOption?.color,

						color_bg: selectedOption?.background,

						name: selectedOption?.name,

						id: selectedOption?.id,

						validation_order: selectedOption?.validationId,

						group_id: selectedOption?.group_id,
					},
				});

				setLoading(false);

				setDisable(false);

				setApiCall(true);

				setOrderStatusModal(false);

				setConfirmPopUp(false);
			},

			(error: AxiosError) => {
				displayCustomError(error);

				setLoading(false);

				setDisable(false);
			},

			orderDetails?.cheeniOrderId
		);
	};

	const changeOrderStatus = (data: any) => {};

	const getPaymentOptions = () => {
		apiService.getPaymentOptions(
			(res: AxiosResponse) => {
				const data = res?.data?.data;

				const paymentTerms: Option[] = data?.paymentTerms?.map((item: any) => {
					return { value: item?.name, id: item?.id };
				});

				const paymentModes: Option[] = data?.paymentModes?.map((item: any) => {
					return { value: item?.name, id: item?.id };
				});

				const paymentStatuses: Option[] = data?.paymentStatuses?.map((item: any) => {
					return { value: item?.name, id: item?.id };
				});

				const updatedData = {
					paymentTerms,

					paymentModes,

					paymentStatuses,
				};

				setPaymentOptions(updatedData);
			},

			(err: AxiosError) => {
				displayCustomError('Something went wrong!');
			}
		);
	};

	const getPaymentHistory = () => {
		apiService.getPaymentHistory(
			(res: AxiosResponse) => {
				const data = res?.data?.data;
				setPaymentHistory(data);
			},
			(err: AxiosError) => {
				displayCustomError('Something went wrong!');
			},
			orderDetails?.orderId
		);
	};

	const filterStatusOptions = (plans: any, selectedStatusId: number) => {
		// const selectedOptionVaildationOrder = orderDetails?.orderStatus?.validation_order;
		// if (
		// 	selectedOptionVaildationOrder &&
		// 	selectedOptionVaildationOrder >= window?.config?.validationOrder
		// ) {
		// 	const updatedPlans = plans?.map((plan: any) => {
		// 		if (plan?.validationId < selectedOptionVaildationOrder || [7, 8, 9].includes(plan?.id)) {
		// 			return { ...plan, disable: true };
		// 		}
		// 		return plan;
		// 	});
		// 	return updatedPlans;
		// }
		// return plans;

		//Only Enable Next Status Group.
		//Also Delivered Status only enable when order is shipped.
		//Post Delivery Status ONLY when customer confirms delivery acceptance
		const updatedPlans = plans?.map((plan: any) => {
			const selectedStatus = plans?.find((plan: any) => selectedStatusId === plan?.id);

			const minCond1 = plan?.groupId !== orderDetails?.orderStatus?.group_id + 1;
			const minCond2 = plan?.groupId === 5 && [6].includes(selectedStatusId);
			const minCond3 = plan?.groupId !== selectedStatus?.groupId;
			const minCond4 = !(orderDetails?.orderStatus?.group_id === 5 && plan?.groupId === 7);

			const cond1 = (minCond1 || minCond2) && minCond3 && minCond4;

			const cond2 = [7, 8, 9].includes(plan?.id);
			const cond3 = plan?.groupId === 4 && [7, 8, 9].includes(selectedStatusId);

			if (cond1 || cond2 || cond3) {
				return { ...plan, disable: true };
			}
			return plan;
		});
		return updatedPlans;
	};

	const transformData = (data: any, selectedStatusId: number) => {
		return data.map((group: any) => {
			const plans = group?.order_statuses?.map((status: any) => {
				return {
					id: status?.order_status_id,
					name: status?.order_status_id === 5 ? `${status.name} *` : status?.name,
					color: group?.color,
					background: group?.color_bg,
					statusID: status?.order_status_id,
					validationId: group?.validation_order,
					groupId: group?.group_id,
				};
			});

			return {
				id: group.group_id,
				name: group.name.toLowerCase(),
				color: group.color,
				colorBg: group.color_bg,
				plans: filterStatusOptions(plans, selectedStatusId),
			};
		});
	};

	const transformOptions = (data: any, selectedStatusId: number) => {
		const plans: Options[] = [];
		data?.forEach((group: any) => {
			group?.order_statuses?.forEach((status: any) => {
				plans?.push({
					id: status?.order_status_id,
					name: status.name,
					color: group?.color,
					background: group?.color_bg,
					statusID: status?.order_status_id,
					validationId: group?.validation_order,
					group_id: group?.group_id,
				});
			});
		});
		return filterStatusOptions(plans, selectedStatusId);
	};

	const getHistory = () => {
		apiService?.getOrderHistory(
			(response: AxiosResponse) => {
				const history = response?.data?.data?.map((item: any) => {
					return {
						...item,
						number: item?.id,
						title: {
							name: item?.user_name,
							date: moment(item?.created_at).format('DD-MMMM-YYYY'),
							time: moment(item?.created_at).format('hh:mma'),
						},
						changes: item?.logs?.map((item: any) => {
							return item?.log;
						}),
					};
				});
				setSteps(history);
			},
			(error: AxiosError) => {
				displayCustomError(error);
			},
			id,
			orderDetails?.cheeniOrderId
		);
	};

	useEffect(() => {
		if (currentUser?.type?.toLowerCase() !== RESTAURANT) {
			apiService.getOrderStatus(
				(response: AxiosResponse) => {
					const transformedData = transformData(
						response?.data?.data,
						orderDetails?.orderStatus?.id
					);
					const transformedOptions = transformOptions(
						response?.data?.data,
						orderDetails?.orderStatus?.id
					);

					const selectedItem = transformedOptions?.find(
						(item: any) => item?.id === orderDetails?.orderStatus?.id
					);
					setStatus(transformedData);
					setAllOptions(transformedOptions);
					if (selectedItem?.id) {
						setSelectedId(selectedItem?.id?.toString());
					}
					setLoading(false);
				},
				(error: AxiosError) => {
					setLoading(false);
					displayCustomError(error);
				}
			);
		} else {
			setLoading(false);
		}
	}, [orderDetails]);

	useEffect(() => {
		if (!isRestaurant) {
			getPaymentOptions();
			getPaymentHistory();
		}
	}, []);

	useEffect(() => {
		getHistory();
	}, [orderDetails]);

	//For Mobile Screen
	useEffect(() => {
		window.addEventListener('resize', updateWindowDimensions);

		return () => {
			window.removeEventListener('resize', updateWindowDimensions);
		};
	}, []);

	useEffect(() => {
		updateWindowDimensions();
	}, []);

	const modals = () => {
		if (shareModal) {
			return (
				<CustomModal
					open={shareModal}
					setOpen={setShareModal}
					title="Share"
					style={{}}
					children={
						<div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '16px' }}>
							<CustomButton
								color="primary"
								title="Share"
								handleClick={() => shareData(orderDetails)}
								styles={{
									width: '130px',
									height: '36px',
									borderRadius: '4px',
									border: '1px solid #FFC51A',
									background: '#ffffff !important',
									color: 'var(--default-text-color) !important',
									':hover': {
										background: '#f0f0f0 !important',
									},
								}}
							/>
							<CustomButton
								color="primary"
								title="Export"
								handleClick={() => {
									exportToCsv(orderDetails);
								}}
								styles={{
									width: '130px',
									height: '36px',
									borderRadius: '4px',
									border: '1px solid #FFC51A',
									background: '#ffffff !important',
									color: 'var(--default-text-color) !important',
									':hover': {
										background: '#f0f0f0 !important',
									},
								}}
							/>
						</div>
					}
				/>
			);
		} else if (confirmPopUp) {
			return (
				<CustomModal
					open={confirmPopUp}
					setOpen={setConfirmPopUp}
					header={false}
					style={{ width: '300px' }}
					children={
						<ConfirmModal
							loading={loading}
							handleClose={() => setConfirmPopUp(false)}
							confirmModal
							content="Do you really want to update the status?"
							handleConfirm={() =>
								statusUpdate(
									selectedOption?.id,
									selectedOption,
									data,
									orderDetails?.orderFulfillmentLifeCycle
								)
							}
						/>
					}
				/>
			);
		} else if (detailsMiodal && details) {
			return (
				<CustomModal
					open={detailsMiodal}
					setOpen={setDetailsModal}
					header={false}
					style={productDetailsModalStyles}
				>
					{/* @ts-ignore */}
					<ProductDetails data={details} setOpenModal={setDetailsModal} />
				</CustomModal>
			);
		}
	};

	if (loading) {
		return <Loading />;
	}

	return (
		<>
			<StyledContainer>
				{windowDimensions?.width <= 800 ? (
					<Box
						display="flex"
						flexDirection="column"
						alignItems="center"
						p={2}
						gap="10px"
						width="100%"
						height="150px"
					>
						<Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
							<Typography
								variant="body1"
								style={{
									maxWidth: '320px',
									display: 'inline-block',
									overflowWrap: 'break-word',
									wordWrap: 'break-word',
									maxHeight: '50px',
									overflow: 'auto',
								}}
							>
								Order From {title}
							</Typography>
							<Box sx={{ cursor: 'pointer' }} onClick={handleClose}>
								<ModalCloseIcon />
							</Box>
						</Box>
						<Status
							style={{
								color: orderDetails?.orderStatus?.color,
								background: orderDetails?.orderStatus?.color_bg,
								width: '100%',
								height: '30px',
							}}
						>
							{orderDetails?.orderStatus?.name &&
								truncateField(orderDetails?.orderStatus?.name, 30)}
						</Status>
						<Box display="flex" alignItems="center" gap="15px" width="100%">
							{currentUser?.type?.toLowerCase() === RESTAURANT &&
							orderDetails?.orderStatus?.validation_order &&
							canEditOrder(orderDetails?.orderStatus?.validation_order) ? (
								editOrderPermission ? (
									<StyledTextButton
										onClick={() =>
											navigate(
												`/${getBaseRoute(currentUser?.type)}/${id}/${
													isRestaurant
														? orderDetails?.supplier?.phone
														: orderDetails?.restaurant?.phone
												}/editOrder/${orderDetails?.orderId}`
											)
										}
									>
										Edit Order
									</StyledTextButton>
								) : (
									<CustomTooltip
										title="You do not have permission to view chats. Contact 
							an administrator to get permission."
										placement="bottom"
									>
										<span>
											<StyledTextButton onClick={() => {}} disabled>
												Edit Order
											</StyledTextButton>
										</span>
									</CustomTooltip>
								)
							) : null}
							{currentUser?.type?.toLowerCase() === RESTAURANT ? (
								<CustomButton
									title="Export"
									color="primary"
									styles={{ height: '36px' }}
									handleClick={() => setShareModal(true)}
								/>
							) : editOrderPermission ? (
								<LabeledSelectField
									statusOptions={status}
									value={selectedId}
									handleChange={handleChange}
									styles={{ width: isMobileWidth ? 'calc(100vw - 32px)' : '333px', height: '36px' }}
									disable={loading}
									customTopMessage={() =>
										showCreditWarning && (
											<StyledMenuItem disabled={true} style={{ opacity: 1 }}>
												<Box p={1} sx={{ background: 'red' }}>
													<Typography
														color={'white'}
														fontWeight={600}
														fontSize={14}
														sx={{ textWrap: 'wrap' }}
													>
														Please note: This order exceeds the credit limit you have set for this
														customer. However, you can still accept this order at your discretion.
													</Typography>
												</Box>
											</StyledMenuItem>
										)
									}
								/>
							) : (
								<CustomTooltip
									title="You do not have permission to change status. Contact 
								an administrator to get permission."
									placement="bottom"
								>
									<span>
										<LabeledSelectField
											statusOptions={status}
											value={selectedId}
											handleChange={() => {}}
											styles={{
												width: isMobileWidth ? 'calc(100vw - 32px)' : '333px',
												height: '36px',
											}}
											disable={true}
										/>
									</span>
								</CustomTooltip>
							)}
						</Box>
					</Box>
				) : (
					<Box
						display="flex"
						justifyContent="space-between"
						alignItems="center"
						p={2}
						width="100%"
						height="56px"
					>
						<Box display="flex" alignItems="center" gap="15px">
							<Typography
								variant="body1"
								style={{
									maxWidth: '320px',
									display: 'inline-block',
									overflowWrap: 'break-word',
									wordWrap: 'break-word',
									maxHeight: '50px',
									overflow: 'auto',
								}}
							>
								{isSupplier ? `Order From ${title}` : `Order To ${title}`}
							</Typography>

							<Status
								style={{
									color: orderDetails?.orderStatus?.color,
									background: orderDetails?.orderStatus?.color_bg,
								}}
							>
								{orderDetails?.orderStatus?.name}
							</Status>
						</Box>
						<Box
							display="flex"
							alignItems="center"
							gap="15px"
							width={isMobileWidth ? 'calc(100vw - 32px)' : 'unset'}
						>
							{orderDetails?.orderStatus?.validation_order &&
							canEditOrder(orderDetails?.orderStatus?.validation_order) &&
							editOrderPermission ? (
								<StyledTextButton
									onClick={() =>
										navigate(
											`/${getBaseRoute(currentUser?.type)}/${id}/${
												isRestaurant
													? orderDetails?.supplier?.phone
													: orderDetails?.restaurant?.phone
											}/editOrder/${orderDetails?.orderId}`
										)
									}
								>
									Edit Order
								</StyledTextButton>
							) : null}
							{currentUser?.type?.toLowerCase() === RESTAURANT ? (
								<CustomButton
									title="Export"
									color="primary"
									styles={{ height: '36px' }}
									handleClick={() => setShareModal(true)}
								/>
							) : editOrderPermission ? (
								<LabeledSelectField
									statusOptions={status}
									value={selectedId}
									handleChange={handleChange}
									styles={{ width: isMobileWidth ? 'calc(100vw - 32px)' : '333px', height: '36px' }}
									disable={loading}
									customTopMessage={() =>
										showCreditWarning && (
											<StyledMenuItem disabled={true} style={{ opacity: 1 }}>
												<Box p={1} sx={{ background: 'red' }}>
													<Typography
														color={'white'}
														fontWeight={600}
														fontSize={14}
														sx={{ textWrap: 'wrap' }}
													>
														Please note: This order exceeds the credit limit you have set for this
														customer. However, you can still accept this order at your discretion.
													</Typography>
												</Box>
											</StyledMenuItem>
										)
									}
								/>
							) : (
								<CustomTooltip
									title="You do not have permission to change status. Contact 
									an administrator to get permission."
									placement="bottom"
								>
									<span>
										<LabeledSelectField
											statusOptions={status}
											value={selectedId}
											handleChange={() => {}}
											styles={{
												width: isMobileWidth ? 'calc(100vw - 32px)' : '333px',
												height: '36px',
											}}
											disable={true}
										/>
									</span>
								</CustomTooltip>
							)}

							<Box sx={{ cursor: 'pointer' }} onClick={handleClose}>
								<ModalCloseIcon />
							</Box>
						</Box>
					</Box>
				)}
				<Divider style={{ width: '100%' }} />
				<CustomTab tabValue={tabValue} handleTabChange={handleTabChange} tabs={tabs} />
				{modals()}
				{selectedOption ? (
					<OrderStatusExtraInfo
						selectedOption={selectedOption}
						open={orderStatusModal}
						setOpen={setOrderStatusModal}
						statusUpdate={statusUpdate}
						loading={loading}
						paymentOptions={paymentOptions}
						total={Number(orderDetails?.total)}
						orderDate={orderDetails?.orderDate}
					/>
				) : null}
			</StyledContainer>
		</>
	);
};

export default ViewOrder;
